module.exports = __webpack_public_path__ + "static/media/open-status.21e9a865.svg";